import {
    Api_Response,
    Base_Filter,
    DELETE,
    GET,
    IBase_Entity,
    PATCH,
    POST,
} from "../base-services";
import {
    Create_Branches_Response,
    IOrganization_Row,
} from "../organization/organization-service";

export class Branch_Service {
    static url = `/organization/branch`;

    static branches: INew_Branch[] = [];

    static async create_branches(
        new_branches: INew_Branch[],
        orgCode: IOrganization_Row["code"],
        api_key: string
    ) {
        return POST<Create_Branches_Response>(
            `${Branch_Service.url}`,
            new_branches,
            {},
            { "x-org": orgCode, authorization: `Bearer ${api_key}` }
        );
    }

    static async get_branches(
        filter: Get_Branches_Filter,
        org_code: string,
        api_key: string
    ) {
        if (!org_code)
            return Promise.reject([
                null,
                { success: false, message: "Organization code is required" },
            ]);

        return GET<Get_Branches_Response>(
            `${Branch_Service.url}`,
            { ...filter, organization: org_code },
            {
                "x-org": org_code,
                authorization: `Bearer ${api_key}`,
            }
        );
    }

    static async get_superadmin_branches(
        filter: Get_Branches_Filter,
        org_code: string
        // api_key: string
    ) {
        return GET<Get_Branches_Response>(
            `${Branch_Service.url}/superadmin`,
            { ...filter, organization: org_code },
            {
                "x-org": org_code,
                "x-master-key": process.env.REACT_APP_MASTER_KEY,
                // authorization: `Bearer ${api_key}`,
            }
        );
    }

    static async edit_branch(
        branch_id: string,
        changes: any,
        org_code: string,
        api_key: string
    ) {
        return PATCH<any[]>(
            `${Branch_Service.url}`,
            changes,
            {
                branchId: branch_id,
            },
            {
                "x-org": org_code,
                authorization: `Bearer ${api_key}`,
            }
        );
    }

    static async delete_branches(
        branch_ids: string[],
        org_code: string
        // api_key: string
    ) {
        return DELETE<any[]>(
            `${Branch_Service.url}`,
            {} as any,
            { branchIds: branch_ids.join(",") },
            {
                "x-org": org_code,
                // authorization: `Bearer ${api_key}`,
            }
        );
    }
}

type Get_Branches_Response = Api_Response<{ rows: any[]; count: number }>;

export type Get_Branches_Filter = Base_Filter & {
    // search?: string;
    name?: string;
    id?: IBranch_Row["id"];
    search?: string;
    apply?: number;
    apiKey: string;
};

export interface INew_Branch {
    name: string;
}

export interface IBranch_Row extends IBase_Entity, INew_Branch {
    id: number;
}
